import { useMutation } from '@tanstack/react-query';
import { type UpdateTagMembersRequest } from 'API/tags-api';
import { tagsQueryKeys } from 'hooks/queries/tags/tag-keys';
import { useRemoveTagMembersMutation } from 'hooks/queries/tags/use-remove-tag-members';
import { useAddTagMembersMutation } from 'hooks/queries/tags/use-add-tag-members';

export const useUpdateTagMembersMutation = () => {
    const { mutateAsync: removeTagMembersMutation } = useRemoveTagMembersMutation();
    const { mutateAsync: addTagMembersMutation } = useAddTagMembersMutation();

    return useMutation({
        mutationKey: tagsQueryKeys.removeTagMembers,
        mutationFn: async ({ tagId, add, remove }: UpdateTagMembersRequest) => {
            remove.length && (await removeTagMembersMutation({ tagId, members: remove }));
            add?.length && (await addTagMembersMutation({ tagId, members: add }));

            return;
        },
    });
};
